
		<ng-container>
			<a [attr.href]="item.url" (click)="itemClick($event)" *ngIf="(!item.routerLink || item.items)  && !item.disabled"
			   (mouseenter)="onMouseEnter()" (keydown.enter)="itemClick($event)"
			   [attr.target]="item.target" [attr.tabindex]="0">
				<i [ngClass]="item.icon"></i>
				<span>{{item.label}}</span>
				<span class="menuitem-badge" *ngIf="item.badge">{{item.badge}}</span>
				<i class="fa fa-fw fa-angle-down layout-menuitem-toggler" *ngIf="item.items"></i>
			</a>
            <a class="disabled" [attr.href]="item.url" (click)="itemClick($event)" *ngIf="(!item.routerLink || item.items)  && item.disabled"
			   (mouseenter)="onMouseEnter()" (keydown.enter)="itemClick($event)"
			   [attr.target]="item.target" [attr.tabindex]="0">
				<i [ngClass]="item.icon"></i>
				<span>{{item.label}}</span>
				<span class="menuitem-badge" *ngIf="item.badge">{{item.badge}}</span>
				<i class="fa fa-fw fa-angle-down layout-menuitem-toggler" *ngIf="item.items"></i>
			</a>
			<a class="disabled" (click)="itemClick($event)" (mouseenter)="onMouseEnter()" *ngIf="item.routerLink && !item.items && item.disabled"
			   [routerLink]="item.routerLink" routerLinkActive="active-menuitem-routerlink"
			   [routerLinkActiveOptions]="{exact: true}" [attr.target]="item.target" [attr.tabindex]="0">
				<i [ngClass]="item.icon"></i>
				<span>{{item.label}}</span>
				<span class="menuitem-badge" *ngIf="item.badge">{{item.badge}}</span>
				<i class="fa fa-fw fa-angle-down layout-menuitem-toggler" *ngIf="item.items"></i>
			</a>
             <a (click)="itemClick($event)" [ngClass]="item.styleClass" (mouseenter)="onMouseEnter()" *ngIf="item.routerLink && !item.items && !item.disabled"
                 [routerLink]="item.routerLink" routerLinkActive="active-menuitem-routerlink"
                [routerLinkActiveOptions]="{exact: true}" [attr.target]="item.target" [attr.tabindex]="0">
                <i [ngClass]="item.icon"></i>
                <span>{{item.label}}</span>
                <span class="menuitem-badge" *ngIf="item.badge">{{item.badge}}</span>
                <i class="fa fa-fw fa-angle-down layout-menuitem-toggler" *ngIf="item.items"></i>
            </a>
			<ng-container *ngIf="item.disabled">
                <div class=" disabled submenu-arrow" *ngIf="item.items"></div>
			<ul *ngIf="item.items && active"
				[@children]="((app.isSlim()||app.isHorizontal()) && root) ? (active ? 'visible' : 'hidden') :
				(active ? 'visibleAnimated' : 'hiddenAnimated')">
				<ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
					<li doctor-app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child.badgeClass"></li>
				</ng-template>
			</ul>
            </ng-container>
            <ng-container *ngIf="!item.disabled">
                <div class="submenu-arrow" *ngIf="item.items"></div>
			<ul *ngIf="item.items && active"
				[@children]="((app.isSlim()||app.isHorizontal()) && root) ? (active ? 'visible' : 'hidden') :
				(active ? 'visibleAnimated' : 'hiddenAnimated')">
				<ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
					<li doctor-app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child.badgeClass"></li>
				</ng-template>
			</ul>
            </ng-container>
		</ng-container>
    